import React from "react";
import { Button, ConnectWalletModal } from "../../components";
import { useRootContext } from "../../context/app-context";
import { useWalletConnect } from "../../context/wallet-connection";
import { handleConnectSignMessage } from "../../utils/buttons.helper";

export default function LoginButton({className}) {
  const {openWalletModal, setOpenWalletModal, isDisabled, isSwitching} = useRootContext();
  const {loading, selectedWallet, currentConnector, disconnectCalled} = useWalletConnect();

  return (
    <div className={`relative ${className}`}>
      <Button
      id="connectWallet"
        onClick={isDisabled ? null :() => setOpenWalletModal(true)}
        disabled={isDisabled}
        className={`primary-gradient px-3 py-3 md:px-5 md:py-[13px] leading-tight ${isDisabled ? "opacity-50 !cursor-not-allowed" : ""}`}
      >
        {handleConnectSignMessage(loading, selectedWallet,isSwitching,currentConnector, true, disconnectCalled)}
      </Button>

      <ConnectWalletModal
        isToggled={openWalletModal}
        setToggled={setOpenWalletModal}
      />
    </div>
  );
}
